import { ProductType } from 'src/type/product';
import { useState, useEffect } from 'react';
import Label from 'src/components/label';
import { useBoolean } from 'src/hooks/use-boolean';
import axios, { endpoints } from 'src/utils/axios';
import { toastError } from 'src/utils/format-error';
import { Grid, Stack, Divider, Typography } from '@mui/material';
import BackButton from 'src/components/ui-kit/back-button';
import InfoGrid from 'src/components/ui-kit/info-grid';
import LoadingContainer from 'src/components/ui-kit/loading-container';
import { isEmpty } from 'lodash';
import ProductFeeTable from '../product-fee-table';

type Props = {
  id: string;
};

export default function ProductDetailView({ id }: Props) {
  const initialize = useBoolean(true);
  const [product, setProduct] = useState<ProductType | null>(null);

  useEffect(() => {
    loadProduct();
  }, []);

  const loadProduct = async () => {
    try {
      initialize.onTrue();
      const { data } = await axios.get<ProductType>(endpoints.product.getById(id));
      setProduct(data);
    } catch (error) {
      toastError(error);
    } finally {
      initialize.onFalse();
    }
  };

  const getInfo = () => {
    if (!product) return [];

    const { name, description, imageUrl, isEnable } = product;

    return [
      { label: 'ชื่อสินค้า', value: name },
      { label: 'รายละเอียด', value: description },
      {
        label: 'รูป',
        value: imageUrl ? <img src={imageUrl} alt="" /> : '-',
      },
      {
        label: 'สถานะ',
        value: (
          <Label variant="soft" color={isEnable ? 'success' : 'error'}>
            {isEnable ? 'เปิดใช้งาน' : 'ปิดใช้งาน'}
          </Label>
        ),
      },
    ];
  };

  return (
    <LoadingContainer loading={initialize.value}>
      <BackButton />
      <Typography variant="h4">สินค้า {product?.name}</Typography>

      {!isEmpty(product) && (
        <Stack spacing={2}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <InfoGrid infos={getInfo()} />
            </Grid>
          </Grid>

          <Divider sx={{ my: 2 }} />

          <ProductFeeTable product={product} />
        </Stack>
      )}
    </LoadingContainer>
  );
}
